"use client";

import type { ReactNode } from "react";

import {
  TOOLTIP_DELAY_MS,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/ui/shadcn-components/tooltip";

interface SimpleTooltipProps {
  content: ReactNode;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  /** Hover delay before the tooltip opens. Default 700ms. */
  delayDuration?: number;
}

/** Convenience wrapper for icon buttons and truncated labels. */
export function SimpleTooltip({
  content,
  children,
  side = "top",
  delayDuration = TOOLTIP_DELAY_MS,
}: SimpleTooltipProps) {
  return (
    <Tooltip delayDuration={delayDuration}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent side={side}>{content}</TooltipContent>
    </Tooltip>
  );
}
